// import React, { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaMars, FaVenus } from "react-icons/fa";
// import { getGender } from "../utils/storage";
// import { calcBmi, bmiCategory, convertVitalsUnit, toMetricVitals } from "../utils/bmi";
// import {
//   validatePersonalInfo,
//   clampPersonalField,
//   todayYmd,
//   VITAL_LIMITS,
//   preventWheelChange,
// } from "../utils/hraValidation";
// import {
//   computeHraScores,
//   getOptionId,
// } from "../utils/hraScoring";
// import HraAssessmentShell from "../Components/HraAssessmentShell";
// import FieldInfo from "../Components/FieldInfo";

// const choice = (id, text, points) => ({ _id: id, text, points });

// const yesNo = (id) => [choice(`${id}-yes`, "Yes", 1), choice(`${id}-no`, "No", 3)];

// const howOften = (id) => [
//   choice(`${id}-rarely`, "Rarely", 1),
//   choice(`${id}-sometimes`, "Sometimes", 2),
//   choice(`${id}-often`, "Often", 3),
// ];

// const ask = (id, category, question, options) => ({
//   _id: id,
//   hraCategoryName: category,
//   gender: "Both",
//   question,
//   options,
// });

// const CARDIAC_QUESTIONS = [
//   ask("Q-C01", "Cardiac Health", "Do you currently have any chronic conditions like heart, kidney, liver, arthritis?", yesNo("Q-C01")),
//   ask("Q-C02", "Cardiac Health", "Has anyone in your family been diagnosed with cancer?", yesNo("Q-C02")),
//   ask("Q-C03", "Cardiac Health", "Do your parents or siblings have diabetes, hypertension, or thyroid?", yesNo("Q-C03")),
//   ask("Q-C04", "Cardiac Health", "Do you have any allergies (dust, food, pollen, drug allergy, etc.)?", yesNo("Q-C04")),
//   ask("Q-C05", "Cardiac Health", "Is there any history of heart disease in your family?", yesNo("Q-C05")),
//   ask("Q-C06", "Cardiac Health", "Any sudden death in family due to heart attack or stroke?", yesNo("Q-C06")),
//   ask("Q-C07", "Cardiac Health", "Do you experience dizziness or brief blackouts?", yesNo("Q-C07")),
//   ask("Q-C08", "Mental Wellbeing", "How often do you feel emotionally balanced or positive?", howOften("Q-C08")),
//   ask("Q-C09", "Mental Wellbeing", "How often do you feel anxious, low, or mentally drained?", [
//     choice("Q-C09-often", "Often", 1),
//     choice("Q-C09-sometimes", "Sometimes", 2),
//     choice("Q-C09-rarely", "Rarely", 3),
//   ]),
// ];

// const LIFESTYLE_QUESTIONS = [
//   ask("Q-L01", "Lifestyle & Activity", "How often do you include walking (e.g., stairs, short walks) in your routine?", howOften("Q-L01")),
//   ask("Q-L02", "Lifestyle & Activity", "Do you feel energetic after your daily activities or work?", [
//     choice("Q-L02-rarely", "Rarely", 1),
//     choice("Q-L02-sometimes", "Sometimes", 2),
//     choice("Q-L02-usually", "Usually", 3),
//   ]),
//   ask("Q-L03", "Lifestyle & Activity", "How often do you exercise or engage in physical activity?", howOften("Q-L03")),
//   ask("Q-L04", "Lifestyle & Activity", "How much time do you usually spend sitting during the day (work, TV, etc.)?", [
//     choice("Q-L04-most", "Most of the day", 1),
//     choice("Q-L04-half", "About half the day", 2),
//     choice("Q-L04-little", "A little of the day", 3),
//   ]),
//   ask("Q-L05", "Metabolic Risk", "How often do you eat processed or fried foods?", [
//     choice("Q-L05-often", "Often", 1),
//     choice("Q-L05-sometimes", "Sometimes", 2),
//     choice("Q-L05-rarely", "Rarely", 3),
//   ]),
//   ask("Q-L06", "Metabolic Risk", "Is your diet balanced with carbs, protein, fiber, fruits and vegetables?", [
//     choice("Q-L06-rarely", "Rarely", 1),
//     choice("Q-L06-sometimes", "Sometimes", 2),
//     choice("Q-L06-usually", "Usually", 3),
//   ]),
//   ask("Q-L07", "Metabolic Risk", "How much water do you usually drink in a day?", [
//     choice("Q-L07-low", "Less than 4 glasses", 1),
//     choice("Q-L07-mid", "4–7 glasses", 2),
//     choice("Q-L07-high", "8 or more glasses", 3),
//   ]),
//   ask("Q-L08", "Metabolic Risk", "How balanced do you consider your daily meals?", [
//     choice("Q-L08-poor", "Not balanced", 1),
//     choice("Q-L08-some", "Somewhat balanced", 2),
//     choice("Q-L08-well", "Well balanced", 3),
//   ]),
//   ask("Q-L09", "Lifestyle & Activity", "Do you smoke or chew tobacco products?", yesNo("Q-L09")),
//   ask("Q-L10", "Lifestyle & Activity", "How often do you drink alcohol?", [
//     choice("Q-L10-often", "Often", 1),
//     choice("Q-L10-sometimes", "Sometimes", 2),
//     choice("Q-L10-never", "Never", 3),
//   ]),
//   ask("Q-L11", "Mental Wellbeing", "How well do you usually sleep?", [
//     choice("Q-L11-poor", "Poorly", 1),
//     choice("Q-L11-ok", "Fairly well", 2),
//     choice("Q-L11-well", "Well", 3),
//   ]),
//   ask("Q-L12", "Mental Wellbeing", "Do you often feel stressed at work or in daily life?", [
//     choice("Q-L12-often", "Often", 1),
//     choice("Q-L12-sometimes", "Sometimes", 2),
//     choice("Q-L12-rarely", "Rarely", 3),
//   ]),
// ];

// const QUESTION_SCREENS = [
//   { name: "Cardiac Health", questions: CARDIAC_QUESTIONS },
//   { name: "Lifestyle & Activity", questions: LIFESTYLE_QUESTIONS },
// ];

// const CATEGORY_DESCRIPTIONS = {
//   default: "Please answer the following questions to help us tailor your wellness plan.",
//   "Cardiac Health": "Please provide details about your heart health and family history to help us tailor your wellness plan.",
//   "Metabolic Risk": "Help us understand your metabolic health markers and related lifestyle factors.",
//   "Lifestyle & Activity": "Tell us about your daily activity, diet, and wellness habits.",
//   "Mental Wellbeing": "Share how stress, sleep, and mental health affect your overall wellbeing.",
// };

// const defaultPersonalInfo = () => ({
//   sex: "",
//   dob: "",
//   heightFt: "",
//   heightIn: "",
//   heightCm: "",
//   weight: "",
//   bpSys: "",
//   bpDia: "",
//   unit: "imperial",
// });

// const filterQuestionsByGender = (questions, gender) =>
//   questions.filter((question) => {
//     if (!question.gender || question.gender === "Unknown" || question.gender === "Both") return true;
//     if (gender === "Male" && question.gender === "Female") return false;
//     if (gender === "Female" && question.gender === "Male") return false;
//     return true;
//   });

// const isPillStyle = (options) =>
//   options.length <= 3 && options.every((o) => (o.text || "").length <= 12);

// const isCheckboxStyle = (question) =>
//   /history|checkbox/i.test(question.question || "") ||
//   (question.options.length === 1 && /yes/i.test(question.options[0]?.text || ""));

// const RadioTile = ({ opt, selected, onSelect, questionId, fullWidth }) => {
//   const id = getOptionId(opt);
//   return (
//     <button
//       type="button"
//       onClick={() => onSelect(questionId, id)}
//       className={`flex items-start gap-3 border rounded-xl px-4 py-4 text-left transition-all ${
//         fullWidth ? "col-span-2 w-full" : ""
//       } ${
//         selected
//           ? "bg-primary-fixed/30 border-primary"
//           : "border-surface-container hover:bg-surface-low bg-surface-lowest"
//       }`}
//     >
//       <span
//         className={`mt-0.5 w-4 h-4 rounded-full border-2 shrink-0 flex items-center justify-center ${
//           selected ? "border-primary bg-primary" : "border-surface-variant"
//         }`}
//       >
//         {selected && <span className="w-1.5 h-1.5 rounded-full bg-white" />}
//       </span>
//       <span className="text-sm text-on-primary-fixed-var leading-snug">{opt.text}</span>
//     </button>
//   );
// };

// const QuestionInput = ({ question, selectedId, onSelect }) => {
//   const options = question.options || [];

//   if (isCheckboxStyle(question)) {
//     const opt = options[0];
//     const optId = getOptionId(opt);
//     const checked = selectedId === optId;
//     return (
//       <label
//         className={`flex items-center gap-3 border rounded-xl px-4 py-4 cursor-pointer transition-all w-full ${
//           checked ? "bg-primary-fixed/30 border-primary" : "border-surface-container hover:bg-surface-low bg-surface-lowest"
//         }`}
//       >
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={() => onSelect(question._id, checked ? null : optId)}
//           className="h-5 w-5 rounded text-primary focus:ring-primary shrink-0"
//         />
//         <span className="text-sm text-on-primary-fixed-var">{opt?.text || question.question}</span>
//       </label>
//     );
//   }

//   if (isPillStyle(options)) {
//     return (
//       <div className="overflow-x-auto pb-1 -mx-1 px-1">
//         <div className="inline-flex rounded-full border border-surface-container overflow-hidden bg-surface-lowest shrink-0">
//           {options.map((opt, i) => {
//             const optId = getOptionId(opt);
//             return (
//               <button
//                 key={optId}
//                 type="button"
//                 onClick={() => onSelect(question._id, optId)}
//                 className={`shrink-0 whitespace-nowrap px-4 sm:px-6 py-2.5 text-sm font-medium transition-all border-r border-surface-container last:border-r-0 ${
//                   selectedId === optId
//                     ? "bg-primary text-white"
//                     : "bg-surface-lowest text-on-primary-fixed-var hover:bg-surface-low"
//                 } ${i === 0 ? "rounded-l-full" : ""} ${i === options.length - 1 ? "rounded-r-full" : ""}`}
//               >
//                 {opt.text}
//               </button>
//             );
//           })}
//         </div>
//       </div>
//     );
//   }

//   const gridOptions = options.length >= 3 ? options.slice(0, 2) : options;
//   const fullWidthOption = options.length >= 3 ? options[2] : null;
//   const extraOptions = options.length > 3 ? options.slice(3) : [];

//   return (
//     <div className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//         {gridOptions.map((opt) => (
//           <RadioTile
//             key={getOptionId(opt)}
//             opt={opt}
//             selected={selectedId === getOptionId(opt)}
//             onSelect={onSelect}
//             questionId={question._id}
//           />
//         ))}
//         {fullWidthOption && (
//           <RadioTile
//             opt={fullWidthOption}
//             selected={selectedId === getOptionId(fullWidthOption)}
//             onSelect={onSelect}
//             questionId={question._id}
//             fullWidth
//           />
//         )}
//       </div>
//       {extraOptions.length > 0 && (
//         <div className="grid grid-cols-1 gap-3">
//           {extraOptions.map((opt) => (
//             <RadioTile
//               key={getOptionId(opt)}
//               opt={opt}
//               selected={selectedId === getOptionId(opt)}
//               onSelect={onSelect}
//               questionId={question._id}
//               fullWidth
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const VITALS_FIELDS = new Set(["weight", "bpSys", "bpDia"]);

// const PersonalInfoStep = ({
//   personalInfo,
//   setPersonalInfo,
//   bmiValue,
//   bmiLabel,
//   errors = {},
//   showAllErrors = false,
// }) => {
//   const [touched, setTouched] = useState({});

//   const toggleUnit = () => {
//     setPersonalInfo((p) => convertVitalsUnit(p, p.unit === "imperial" ? "metric" : "imperial"));
//   };

//   const markTouched = (name) => setTouched((t) => ({ ...t, [name]: true }));

//   const showError = (field) => {
//     if (!errors[field]) return false;
//     if (field === "bp") return showAllErrors || (touched.bpSys && touched.bpDia);
//     if (VITALS_FIELDS.has(field)) return showAllErrors || touched[field];
//     return showAllErrors;
//   };

//   const updateField = (name, value) => {
//     const clamped = ["heightFt", "heightIn", "heightCm", "weight", "bpSys", "bpDia"].includes(name)
//       ? clampPersonalField(name, value, personalInfo.unit)
//       : value;
//     if (VITALS_FIELDS.has(name) && value !== "") markTouched(name);
//     setPersonalInfo((p) => ({ ...p, [name]: clamped }));
//   };

//   const maxDate = todayYmd();
//   const numProps = { onWheel: preventWheelChange };

//   return (
//     <div className="space-y-6 sm:space-y-8">
//       <div>
//         <p className="font-semibold text-on-primary-fixed-var mb-1">Biological Sex</p>
//         <p className="text-xs text-on-surface-variant mb-4 leading-relaxed">
//           This information helps us tailor specific health guidelines and risk factors based on biological differences.
//         </p>
//         <div className="grid grid-cols-2 gap-3 sm:gap-4">
//           {[
//             { value: "Male", icon: FaMars },
//             { value: "Female", icon: FaVenus },
//           ].map(({ value, icon: Icon }) => (
//             <button
//               key={value}
//               type="button"
//               onClick={() => setPersonalInfo((p) => ({ ...p, sex: value }))}
//               className={`flex flex-col items-center justify-center gap-2 border rounded-xl py-4 sm:py-6 transition-all ${
//                 personalInfo.sex === value
//                   ? "bg-primary-fixed/30 border-primary"
//                   : "border-surface-container hover:bg-surface-low bg-surface-lowest"
//               }`}
//             >
//               <Icon className="text-on-surface-variant text-xl" />
//               <span className="font-medium text-on-primary-fixed-var">{value}</span>
//             </button>
//           ))}
//         </div>
//         {showError("sex") && <p className="text-xs text-error mt-2">{errors.sex}</p>}
//       </div>

//       <div>
//         <p className="font-semibold text-on-primary-fixed-var mb-1">Date of Birth</p>
//         <p className="text-xs text-on-surface-variant mb-3">Age is a key factor in many health calculations.</p>
//         <input
//           type="date"
//           value={personalInfo.dob}
//           max={maxDate}
//           onChange={(e) => updateField("dob", e.target.value)}
//           className="w-full border border-surface-container rounded-xl px-4 py-3 text-sm bg-surface-lowest focus:ring-primary focus:border-primary"
//         />
//         {showError("dob") && <p className="text-xs text-error mt-2">{errors.dob}</p>}
//       </div>

//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
//         <div>
//           <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
//             Height
//             <FieldInfo
//               text={
//                 personalInfo.unit === "imperial"
//                   ? `Height in feet and inches. Feet: ${VITAL_LIMITS.heightFt.min}–${VITAL_LIMITS.heightFt.max}, inches: ${VITAL_LIMITS.heightIn.min}–${VITAL_LIMITS.heightIn.max}.`
//                   : `Height in centimetres. Valid range: ${VITAL_LIMITS.heightCm.min}–${VITAL_LIMITS.heightCm.max} cm.`
//               }
//             />
//           </p>
//           <p className="text-xs text-on-surface-variant mb-3">Used for BMI calculation.</p>
//           {personalInfo.unit === "imperial" ? (
//             <div className="flex gap-2">
//               <div className="flex-1 relative">
//                 <input
//                   type="number"
//                   min={VITAL_LIMITS.heightFt.min}
//                   max={VITAL_LIMITS.heightFt.max}
//                   placeholder={`${VITAL_LIMITS.heightFt.min}–${VITAL_LIMITS.heightFt.max}`}
//                   value={personalInfo.heightFt}
//                   onChange={(e) => updateField("heightFt", e.target.value)}
//                   {...numProps}
//                   className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest pr-10"
//                 />
//                 <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-on-surface-variant">ft</span>
//               </div>
//               <div className="flex-1 relative">
//                 <input
//                   type="number"
//                   min={VITAL_LIMITS.heightIn.min}
//                   max={VITAL_LIMITS.heightIn.max}
//                   placeholder={`${VITAL_LIMITS.heightIn.min}–${VITAL_LIMITS.heightIn.max}`}
//                   value={personalInfo.heightIn}
//                   onChange={(e) => updateField("heightIn", e.target.value)}
//                   {...numProps}
//                   className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest pr-10"
//                 />
//                 <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-on-surface-variant">in</span>
//               </div>
//             </div>
//           ) : (
//             <input
//               type="number"
//               min={VITAL_LIMITS.heightCm.min}
//               max={VITAL_LIMITS.heightCm.max}
//               placeholder={`${VITAL_LIMITS.heightCm.min}–${VITAL_LIMITS.heightCm.max}`}
//               value={personalInfo.heightCm}
//               onChange={(e) => updateField("heightCm", e.target.value)}
//               {...numProps}
//               className="w-full border border-surface-container rounded-xl px-4 py-3 text-sm bg-surface-lowest"
//             />
//           )}
//           <button type="button" onClick={toggleUnit} className="text-xs text-primary mt-2 hover:underline font-medium">
//             Switch to {personalInfo.unit === "imperial" ? "Metric (cm)" : "Imperial (ft/in)"}
//           </button>
//           {showError("height") && <p className="text-xs text-error mt-2">{errors.height}</p>}
//         </div>

//         <div>
//           <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
//             Weight
//             <FieldInfo
//               text={
//                 personalInfo.unit === "imperial"
//                   ? `Body weight in pounds. Valid range: ${VITAL_LIMITS.weightLbs.min}–${VITAL_LIMITS.weightLbs.max} lbs.`
//                   : `Body weight in kilograms. Valid range: ${VITAL_LIMITS.weightKg.min}–${VITAL_LIMITS.weightKg.max} kg.`
//               }
//             />
//           </p>
//           <p className="text-xs text-on-surface-variant mb-3">Used for BMI calculation.</p>
//           <div className="flex items-stretch gap-0 border border-surface-container rounded-xl overflow-hidden bg-surface-lowest">
//             <input
//               type="number"
//               max={personalInfo.unit === "imperial" ? VITAL_LIMITS.weightLbs.max : VITAL_LIMITS.weightKg.max}
//               placeholder={
//                 personalInfo.unit === "imperial"
//                   ? `${VITAL_LIMITS.weightLbs.min}–${VITAL_LIMITS.weightLbs.max}`
//                   : `${VITAL_LIMITS.weightKg.min}–${VITAL_LIMITS.weightKg.max}`
//               }
//               value={personalInfo.weight}
//               onChange={(e) => updateField("weight", e.target.value)}
//               onBlur={() => markTouched("weight")}
//               {...numProps}
//               className="flex-1 px-4 py-3 text-sm border-0 focus:ring-2 bg-transparent rounded-l-xl focus:ring-primary"
//             />
//             <span className="flex items-center px-4 text-sm text-on-surface-variant border-l border-surface-container bg-surface-low shrink-0">
//               {personalInfo.unit === "imperial" ? "lbs" : "kg"}
//             </span>
//           </div>
//           <button type="button" onClick={toggleUnit} className="text-xs text-primary mt-2 hover:underline font-medium">
//             Switch to {personalInfo.unit === "imperial" ? "Metric (kg)" : "Imperial (lbs)"}
//           </button>
//           {showError("weight") && <p className="text-xs text-error mt-2">{errors.weight}</p>}
//         </div>
//       </div>

//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
//         <div>
//           <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
//             Blood Pressure
//             <FieldInfo
//               text={`Systolic (upper): ${VITAL_LIMITS.bpSys.min}–${VITAL_LIMITS.bpSys.max} mmHg. Diastolic (lower): ${VITAL_LIMITS.bpDia.min}–${VITAL_LIMITS.bpDia.max} mmHg.`}
//             />
//           </p>
//           <p className="text-xs text-on-surface-variant mb-3">Resting blood pressure reading.</p>
//           <div className="flex items-start gap-2">
//             <div className="flex-1 min-w-0">
//               <input
//                 type="number"
//                 max={VITAL_LIMITS.bpSys.max}
//                 placeholder={`${VITAL_LIMITS.bpSys.min}–${VITAL_LIMITS.bpSys.max}`}
//                 value={personalInfo.bpSys}
//                 onChange={(e) => updateField("bpSys", e.target.value)}
//                 onBlur={() => markTouched("bpSys")}
//                 {...numProps}
//                 className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest"
//               />
//               {showError("bpSys") && <p className="text-xs text-error mt-1">{errors.bpSys}</p>}
//             </div>
//             <span className="text-on-surface-variant font-medium pt-3">/</span>
//             <div className="flex-1 min-w-0">
//               <input
//                 type="number"
//                 max={VITAL_LIMITS.bpDia.max}
//                 placeholder={`${VITAL_LIMITS.bpDia.min}–${VITAL_LIMITS.bpDia.max}`}
//                 value={personalInfo.bpDia}
//                 onChange={(e) => updateField("bpDia", e.target.value)}
//                 onBlur={() => markTouched("bpDia")}
//                 {...numProps}
//                 className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest"
//               />
//               {showError("bpDia") && <p className="text-xs text-error mt-1">{errors.bpDia}</p>}
//             </div>
//             <span className="text-xs text-on-surface-variant shrink-0 font-medium pt-3">mmHg</span>
//           </div>
//           {showError("bp") && <p className="text-xs text-error mt-2">{errors.bp}</p>}
//         </div>

//         <div className="bg-primary-fixed/25 border border-primary-fixed-dim rounded-xl p-4 flex flex-col justify-center min-h-[100px]">
//           <p className="text-[10px] font-bold uppercase tracking-widest text-primary mb-3">Calculated BMI</p>
//           <div className="flex items-end justify-between gap-4">
//             <span className="text-4xl font-bold text-on-primary-fixed-var tabular-nums">
//               {bmiValue != null ? bmiValue.toFixed(1) : "--.-"}
//             </span>
//             <div className="text-right">
//               <p className="text-xs text-on-surface-variant mb-0.5">Category</p>
//               <p className="font-semibold text-primary">{bmiLabel}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const HraQuestionsPage = () => {
//   const navigate = useNavigate();
//   const gender = getGender();
//   const questionScreens = useMemo(
//     () => QUESTION_SCREENS.map((screen) => ({
//       ...screen,
//       questions: filterQuestionsByGender(screen.questions, gender),
//     })),
//     [gender]
//   );
//   const allQuestions = useMemo(
//     () => questionScreens.flatMap((screen) => screen.questions),
//     [questionScreens]
//   );
//   const [answers, setAnswers] = useState({});
//   const [stepIndex, setStepIndex] = useState(0);
//   const [personalInfo, setPersonalInfo] = useState(defaultPersonalInfo);
//   const [savedPersonalInfo, setSavedPersonalInfo] = useState(null);
//   const [personalErrorsShown, setPersonalErrorsShown] = useState(false);

//   useEffect(() => {
//     if (gender === "Male" || gender === "Female") {
//       setPersonalInfo((p) => ({ ...p, sex: p.sex || gender }));
//     }
//   }, [gender]);

//   const totalSteps = 1 + questionScreens.length;
//   const lastQuestionStep = questionScreens.length;

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [stepIndex]);

//   const isPersonalStep = stepIndex === 0;
//   const currentCategoryStep = !isPersonalStep ? questionScreens[stepIndex - 1] : null;

//   const stepLabel = isPersonalStep
//     ? "Personal Information"
//     : currentCategoryStep?.name || "Questions";

//   const firstCategoryWithQuestions = questionScreens[0];

//   const bmiValue = calcBmi({ ...personalInfo, unit: personalInfo.unit || "imperial" });
//   const bmiLabel = bmiCategory(bmiValue);

//   const personalValidation = useMemo(() => validatePersonalInfo(personalInfo), [personalInfo]);
//   const personalStepValid = personalValidation.valid;

//   const stepQuestions = currentCategoryStep?.questions || [];
//   const stepAnswered = isPersonalStep
//     ? personalStepValid
//     : stepQuestions.length > 0 && stepQuestions.every((q) => answers[q._id]);

//   const handleSaveExit = () => {
//     navigate("/hra-category");
//   };

//   const handleAnswerSelect = (questionId, optionId) => {
//     setAnswers((prev) => {
//       const next = { ...prev };
//       if (optionId === null) delete next[questionId];
//       else next[questionId] = optionId;
//       return next;
//     });
//   };

//   const buildPersonalInfoPayload = () => {
//     const bmi = calcBmi({ ...personalInfo, unit: personalInfo.unit || "imperial" });
//     const category = bmiCategory(bmi);
//     const metric = toMetricVitals(personalInfo);
//     const bp =
//       personalInfo.bpSys && personalInfo.bpDia
//         ? `${personalInfo.bpSys}/${personalInfo.bpDia}`
//         : "";
//     return {
//       ...personalInfo,
//       bmi,
//       bmiCategory: category,
//       heightCm: Math.round(metric.heightCm * 10) / 10,
//       weightKg: Math.round(metric.weightKg * 10) / 10,
//       bp,
//     };
//   };

//   const handleSubmit = (info) => {
//     const scores = computeHraScores(allQuestions, answers, {});
//     navigate("/hra-result", {
//       state: {
//         ...scores,
//         totalQuestions: allQuestions.length,
//         answeredQuestions: Object.keys(answers).length,
//         message: "Assessment completed",
//         personalInfo: info,
//         completedAt: new Date().toISOString(),
//       },
//     });
//   };

//   const handleNext = () => {
//     if (isPersonalStep) {
//       if (!personalStepValid) {
//         setPersonalErrorsShown(true);
//         return;
//       }
//       const info = buildPersonalInfoPayload();
//       setSavedPersonalInfo(info);
//       setStepIndex(1);
//       return;
//     }
//     if (stepIndex >= lastQuestionStep) {
//       handleSubmit(savedPersonalInfo || buildPersonalInfoPayload());
//       return;
//     }
//     setStepIndex(stepIndex + 1);
//   };

//   const handleBack = () => {
//     setStepIndex((current) => Math.max(0, current - 1));
//   };

//   const nextCategoryAfterCurrent = questionScreens[stepIndex]?.name;

//   const continueLabel = isPersonalStep
//     ? `Continue to ${firstCategoryWithQuestions?.name || "Assessment"}`
//     : stepIndex >= lastQuestionStep
//       ? "Submit"
//       : nextCategoryAfterCurrent
//         ? `Continue to ${nextCategoryAfterCurrent}`
//         : "Next Step";

//   const renderContent = () => {
//     if (isPersonalStep) {
//       return (
//         <>
//           <h2 className="text-xl font-bold text-on-primary-fixed-var mb-8">Personal Information</h2>
//           <PersonalInfoStep
//             personalInfo={personalInfo}
//             setPersonalInfo={setPersonalInfo}
//             bmiValue={bmiValue}
//             bmiLabel={bmiLabel}
//             errors={personalValidation.errors}
//             showAllErrors={personalErrorsShown}
//           />
//         </>
//       );
//     }

//     if (currentCategoryStep && stepQuestions.length > 0) {
//       return (
//         <>
//           <h2 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var mb-2">
//             {currentCategoryStep.name}
//           </h2>
//           <p className="text-sm text-on-surface-variant mb-8 leading-relaxed">
//             {CATEGORY_DESCRIPTIONS[currentCategoryStep.name] || CATEGORY_DESCRIPTIONS.default}
//           </p>
//           <div className="space-y-6 sm:space-y-10">
//             {stepQuestions.map((question, idx) => (
//               <div key={question._id}>
//                 <p className="font-semibold text-on-primary-fixed-var mb-1">
//                   {!isCheckboxStyle(question) && `${idx + 1}. `}
//                   {question.question}
//                 </p>
//                 {question.instruction && (
//                   <p className="text-xs text-on-surface-variant italic mb-4">{question.instruction}</p>
//                 )}
//                 {!question.instruction && !isCheckboxStyle(question) && <div className="mb-4" />}
//                 <QuestionInput
//                   question={question}
//                   selectedId={answers[question._id]}
//                   onSelect={handleAnswerSelect}
//                 />
//               </div>
//             ))}
//           </div>
//         </>
//       );
//     }

//     return <p className="text-center text-on-surface-variant py-12">No questions available.</p>;
//   };

//   return (
//     <HraAssessmentShell
//       stepIndex={stepIndex}
//       totalSteps={totalSteps}
//       stepLabel={stepLabel}
//       onSaveExit={handleSaveExit}
//       onBack={handleBack}
//       onNext={handleNext}
//       nextLabel={continueLabel}
//       canProceed={stepAnswered && (isPersonalStep || (stepQuestions.length > 0 && !!currentCategoryStep))}
//       showBack={!isPersonalStep}
//     >
//       {renderContent()}
//     </HraAssessmentShell>
//   );
// };

// export default HraQuestionsPage;


import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaMars, FaVenus } from "react-icons/fa";
import { getHraQuestions, submitHraAnswers } from "../api/hra.api";
import { editProfile } from "../api/staff.api";
import { getStaffId, getGender } from "../utils/storage";
import LoadingState from "../Components/States/LoadingState";
import { calcBmi, bmiCategory, convertVitalsUnit, toMetricVitals } from "../utils/bmi";
import {
  validatePersonalInfo,
  clampPersonalField,
  todayYmd,
  VITAL_LIMITS,
  preventWheelChange,
} from "../utils/hraValidation";
import {
  computeHraScores,
  groupIntoFixedCategories,
  getOptionId,
} from "../utils/hraScoring";
import HraAssessmentShell from "../Components/HraAssessmentShell";
import FieldInfo from "../Components/FieldInfo";
import { toast } from "../Components/Toast";

const FIXED_CATEGORY_COUNT = 4;
const HRA_DRAFT_KEY = "hraDraft";

const CATEGORY_DESCRIPTIONS = {
  default: "Please answer the following questions to help us tailor your wellness plan.",
  "Cardiac Health": "Please provide details about your heart health and family history to help us tailor your wellness plan.",
  "Metabolic Risk": "Help us understand your metabolic health markers and related lifestyle factors.",
  "Lifestyle & Activity": "Tell us about your daily activity, diet, and wellness habits.",
  "Mental Wellbeing": "Share how stress, sleep, and mental health affect your overall wellbeing.",
};

const defaultPersonalInfo = () => ({
  sex: "",
  dob: "",
  heightFt: "",
  heightIn: "",
  heightCm: "",
  weight: "",
  bpSys: "",
  bpDia: "",
  unit: "imperial",
});

const filterQuestionsByGender = (questions, gender) =>
  questions.filter((question) => {
    if (!question.gender || question.gender === "Unknown" || question.gender === "Both") return true;
    if (gender === "Male" && question.gender === "Female") return false;
    if (gender === "Female" && question.gender === "Male") return false;
    return true;
  });

const isPillStyle = (options) =>
  options.length <= 3 && options.every((o) => (o.text || "").length <= 12);

const isCheckboxStyle = (question) =>
  /history|checkbox/i.test(question.question || "") ||
  (question.options.length === 1 && /yes/i.test(question.options[0]?.text || ""));

const RadioTile = ({ opt, selected, onSelect, questionId, fullWidth }) => {
  const id = getOptionId(opt);
  return (
    <button
      type="button"
      onClick={() => onSelect(questionId, id)}
      className={`flex items-start gap-3 border rounded-xl px-4 py-4 text-left transition-all ${fullWidth ? "col-span-2 w-full" : ""
        } ${selected
          ? "bg-primary-fixed/30 border-primary"
          : "border-surface-container hover:bg-surface-low bg-surface-lowest"
        }`}
    >
      <span
        className={`mt-0.5 w-4 h-4 rounded-full border-2 shrink-0 flex items-center justify-center ${selected ? "border-primary bg-primary" : "border-surface-variant"
          }`}
      >
        {selected && <span className="w-1.5 h-1.5 rounded-full bg-white" />}
      </span>
      <span className="text-sm text-on-primary-fixed-var leading-snug">{opt.text}</span>
    </button>
  );
};

const QuestionInput = ({ question, selectedId, onSelect }) => {
  const options = question.options || [];

  if (isCheckboxStyle(question)) {
    const opt = options[0];
    const optId = getOptionId(opt);
    const checked = selectedId === optId;
    return (
      <label
        className={`flex items-center gap-3 border rounded-xl px-4 py-4 cursor-pointer transition-all w-full ${checked ? "bg-primary-fixed/30 border-primary" : "border-surface-container hover:bg-surface-low bg-surface-lowest"
          }`}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onSelect(question._id, checked ? null : optId)}
          className="h-5 w-5 rounded text-primary focus:ring-primary shrink-0"
        />
        <span className="text-sm text-on-primary-fixed-var">{opt?.text || question.question}</span>
      </label>
    );
  }

  if (isPillStyle(options)) {
    return (
      <div className="overflow-x-auto pb-1 -mx-1 px-1">
        <div className="inline-flex rounded-full border border-surface-container overflow-hidden bg-surface-lowest shrink-0">
          {options.map((opt, i) => {
            const optId = getOptionId(opt);
            return (
              <button
                key={optId}
                type="button"
                onClick={() => onSelect(question._id, optId)}
                className={`shrink-0 whitespace-nowrap px-4 sm:px-6 py-2.5 text-sm font-medium transition-all border-r border-surface-container last:border-r-0 ${selectedId === optId
                    ? "bg-primary text-white"
                    : "bg-surface-lowest text-on-primary-fixed-var hover:bg-surface-low"
                  } ${i === 0 ? "rounded-l-full" : ""} ${i === options.length - 1 ? "rounded-r-full" : ""}`}
              >
                {opt.text}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  const gridOptions = options.length >= 3 ? options.slice(0, 2) : options;
  const fullWidthOption = options.length >= 3 ? options[2] : null;
  const extraOptions = options.length > 3 ? options.slice(3) : [];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {gridOptions.map((opt) => (
          <RadioTile
            key={getOptionId(opt)}
            opt={opt}
            selected={selectedId === getOptionId(opt)}
            onSelect={onSelect}
            questionId={question._id}
          />
        ))}
        {fullWidthOption && (
          <RadioTile
            opt={fullWidthOption}
            selected={selectedId === getOptionId(fullWidthOption)}
            onSelect={onSelect}
            questionId={question._id}
            fullWidth
          />
        )}
      </div>
      {extraOptions.length > 0 && (
        <div className="grid grid-cols-1 gap-3">
          {extraOptions.map((opt) => (
            <RadioTile
              key={getOptionId(opt)}
              opt={opt}
              selected={selectedId === getOptionId(opt)}
              onSelect={onSelect}
              questionId={question._id}
              fullWidth
            />
          ))}
        </div>
      )}
    </div>
  );
};

const VITALS_FIELDS = new Set(["weight", "bpSys", "bpDia"]);

const PersonalInfoStep = ({
  personalInfo,
  setPersonalInfo,
  bmiValue,
  bmiLabel,
  errors = {},
  showAllErrors = false,
}) => {
  const [touched, setTouched] = useState({});

  const toggleUnit = () => {
    setPersonalInfo((p) => convertVitalsUnit(p, p.unit === "imperial" ? "metric" : "imperial"));
  };

  const markTouched = (name) => setTouched((t) => ({ ...t, [name]: true }));

  const showError = (field) => {
    if (!errors[field]) return false;
    if (field === "bp") return showAllErrors || (touched.bpSys && touched.bpDia);
    if (VITALS_FIELDS.has(field)) return showAllErrors || touched[field];
    return showAllErrors;
  };

  const updateField = (name, value) => {
    const clamped = ["heightFt", "heightIn", "heightCm", "weight", "bpSys", "bpDia"].includes(name)
      ? clampPersonalField(name, value, personalInfo.unit)
      : value;
    if (VITALS_FIELDS.has(name) && value !== "") markTouched(name);
    setPersonalInfo((p) => ({ ...p, [name]: clamped }));
  };

  const maxDate = todayYmd();
  const numProps = { onWheel: preventWheelChange };

  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <p className="font-semibold text-on-primary-fixed-var mb-1">Biological Sex</p>
        <p className="text-xs text-on-surface-variant mb-4 leading-relaxed">
          This information helps us tailor specific health guidelines and risk factors based on biological differences.
        </p>
        <div className="grid grid-cols-2 gap-3 sm:gap-4">
          {[
            { value: "Male", icon: FaMars },
            { value: "Female", icon: FaVenus },
          ].map(({ value, icon: Icon }) => (
            <button
              key={value}
              type="button"
              onClick={() => setPersonalInfo((p) => ({ ...p, sex: value }))}
              className={`flex flex-col items-center justify-center gap-2 border rounded-xl py-4 sm:py-6 transition-all ${personalInfo.sex === value
                  ? "bg-primary-fixed/30 border-primary"
                  : "border-surface-container hover:bg-surface-low bg-surface-lowest"
                }`}
            >
              <Icon className="text-on-surface-variant text-xl" />
              <span className="font-medium text-on-primary-fixed-var">{value}</span>
            </button>
          ))}
        </div>
        {showError("sex") && <p className="text-xs text-error mt-2">{errors.sex}</p>}
      </div>

      <div>
        <p className="font-semibold text-on-primary-fixed-var mb-1">Date of Birth</p>
        <p className="text-xs text-on-surface-variant mb-3">Age is a key factor in many health calculations.</p>
        <input
          type="date"
          value={personalInfo.dob}
          max={maxDate}
          onChange={(e) => updateField("dob", e.target.value)}
          className="w-full border border-surface-container rounded-xl px-4 py-3 text-sm bg-surface-lowest focus:ring-primary focus:border-primary"
        />
        {showError("dob") && <p className="text-xs text-error mt-2">{errors.dob}</p>}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <div>
          <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
            Height
            <FieldInfo
              text={
                personalInfo.unit === "imperial"
                  ? `Height in feet and inches. Feet: ${VITAL_LIMITS.heightFt.min}–${VITAL_LIMITS.heightFt.max}, inches: ${VITAL_LIMITS.heightIn.min}–${VITAL_LIMITS.heightIn.max}.`
                  : `Height in centimetres. Valid range: ${VITAL_LIMITS.heightCm.min}–${VITAL_LIMITS.heightCm.max} cm.`
              }
            />
          </p>
          <p className="text-xs text-on-surface-variant mb-3">Used for BMI calculation.</p>
          {personalInfo.unit === "imperial" ? (
            <div className="flex gap-2">
              <div className="flex-1 relative">
                <input
                  type="number"
                  min={VITAL_LIMITS.heightFt.min}
                  max={VITAL_LIMITS.heightFt.max}
                  placeholder={`${VITAL_LIMITS.heightFt.min}–${VITAL_LIMITS.heightFt.max}`}
                  value={personalInfo.heightFt}
                  onChange={(e) => updateField("heightFt", e.target.value)}
                  {...numProps}
                  className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest pr-10"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-on-surface-variant">ft</span>
              </div>
              <div className="flex-1 relative">
                <input
                  type="number"
                  min={VITAL_LIMITS.heightIn.min}
                  max={VITAL_LIMITS.heightIn.max}
                  placeholder={`${VITAL_LIMITS.heightIn.min}–${VITAL_LIMITS.heightIn.max}`}
                  value={personalInfo.heightIn}
                  onChange={(e) => updateField("heightIn", e.target.value)}
                  {...numProps}
                  className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest pr-10"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-on-surface-variant">in</span>
              </div>
            </div>
          ) : (
            <input
              type="number"
              min={VITAL_LIMITS.heightCm.min}
              max={VITAL_LIMITS.heightCm.max}
              placeholder={`${VITAL_LIMITS.heightCm.min}–${VITAL_LIMITS.heightCm.max}`}
              value={personalInfo.heightCm}
              onChange={(e) => updateField("heightCm", e.target.value)}
              {...numProps}
              className="w-full border border-surface-container rounded-xl px-4 py-3 text-sm bg-surface-lowest"
            />
          )}
          <button type="button" onClick={toggleUnit} className="text-xs text-primary mt-2 hover:underline font-medium">
            Switch to {personalInfo.unit === "imperial" ? "Metric (cm)" : "Imperial (ft/in)"}
          </button>
          {showError("height") && <p className="text-xs text-error mt-2">{errors.height}</p>}
        </div>

        <div>
          <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
            Weight
            <FieldInfo
              text={
                personalInfo.unit === "imperial"
                  ? `Body weight in pounds. Valid range: ${VITAL_LIMITS.weightLbs.min}–${VITAL_LIMITS.weightLbs.max} lbs.`
                  : `Body weight in kilograms. Valid range: ${VITAL_LIMITS.weightKg.min}–${VITAL_LIMITS.weightKg.max} kg.`
              }
            />
          </p>
          <p className="text-xs text-on-surface-variant mb-3">Used for BMI calculation.</p>
          <div className="flex items-stretch gap-0 border border-surface-container rounded-xl overflow-hidden bg-surface-lowest">
            <input
              type="number"
              max={personalInfo.unit === "imperial" ? VITAL_LIMITS.weightLbs.max : VITAL_LIMITS.weightKg.max}
              placeholder={
                personalInfo.unit === "imperial"
                  ? `${VITAL_LIMITS.weightLbs.min}–${VITAL_LIMITS.weightLbs.max}`
                  : `${VITAL_LIMITS.weightKg.min}–${VITAL_LIMITS.weightKg.max}`
              }
              value={personalInfo.weight}
              onChange={(e) => updateField("weight", e.target.value)}
              onBlur={() => markTouched("weight")}
              {...numProps}
              className="flex-1 px-4 py-3 text-sm border-0 focus:ring-2 bg-transparent rounded-l-xl focus:ring-primary"
            />
            <span className="flex items-center px-4 text-sm text-on-surface-variant border-l border-surface-container bg-surface-low shrink-0">
              {personalInfo.unit === "imperial" ? "lbs" : "kg"}
            </span>
          </div>
          <button type="button" onClick={toggleUnit} className="text-xs text-primary mt-2 hover:underline font-medium">
            Switch to {personalInfo.unit === "imperial" ? "Metric (kg)" : "Imperial (lbs)"}
          </button>
          {showError("weight") && <p className="text-xs text-error mt-2">{errors.weight}</p>}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <div>
          <p className="font-semibold text-on-primary-fixed-var mb-1 inline-flex items-center flex-wrap">
            Blood Pressure
            <FieldInfo
              text={`Systolic (upper): ${VITAL_LIMITS.bpSys.min}–${VITAL_LIMITS.bpSys.max} mmHg. Diastolic (lower): ${VITAL_LIMITS.bpDia.min}–${VITAL_LIMITS.bpDia.max} mmHg.`}
            />
          </p>
          <p className="text-xs text-on-surface-variant mb-3">Resting blood pressure reading.</p>
          <div className="flex items-start gap-2">
            <div className="flex-1 min-w-0">
              <input
                type="number"
                max={VITAL_LIMITS.bpSys.max}
                placeholder={`${VITAL_LIMITS.bpSys.min}–${VITAL_LIMITS.bpSys.max}`}
                value={personalInfo.bpSys}
                onChange={(e) => updateField("bpSys", e.target.value)}
                onBlur={() => markTouched("bpSys")}
                {...numProps}
                className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest"
              />
              {showError("bpSys") && <p className="text-xs text-error mt-1">{errors.bpSys}</p>}
            </div>
            <span className="text-on-surface-variant font-medium pt-3">/</span>
            <div className="flex-1 min-w-0">
              <input
                type="number"
                max={VITAL_LIMITS.bpDia.max}
                placeholder={`${VITAL_LIMITS.bpDia.min}–${VITAL_LIMITS.bpDia.max}`}
                value={personalInfo.bpDia}
                onChange={(e) => updateField("bpDia", e.target.value)}
                onBlur={() => markTouched("bpDia")}
                {...numProps}
                className="w-full border border-surface-container rounded-xl px-3 py-3 text-sm bg-surface-lowest"
              />
              {showError("bpDia") && <p className="text-xs text-error mt-1">{errors.bpDia}</p>}
            </div>
            <span className="text-xs text-on-surface-variant shrink-0 font-medium pt-3">mmHg</span>
          </div>
          {showError("bp") && <p className="text-xs text-error mt-2">{errors.bp}</p>}
        </div>

        <div className="bg-primary-fixed/25 border border-primary-fixed-dim rounded-xl p-4 flex flex-col justify-center min-h-[100px]">
          <p className="text-[10px] font-bold uppercase tracking-widest text-primary mb-3">Calculated BMI</p>
          <div className="flex items-end justify-between gap-4">
            <span className="text-4xl font-bold text-on-primary-fixed-var tabular-nums">
              {bmiValue != null ? bmiValue.toFixed(1) : "--.-"}
            </span>
            <div className="text-right">
              <p className="text-xs text-on-surface-variant mb-0.5">Category</p>
              <p className="font-semibold text-primary">{bmiLabel}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HraQuestionsPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [allQuestions, setAllQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [staffId, setStaffId] = useState("");
  const [stepIndex, setStepIndex] = useState(0);
  const [personalInfo, setPersonalInfo] = useState(defaultPersonalInfo);
  const [savedPersonalInfo, setSavedPersonalInfo] = useState(null);
  const [personalErrorsShown, setPersonalErrorsShown] = useState(false);

  const navigate = useNavigate();
  const gender = getGender();

  useEffect(() => {
    const storedStaffId = getStaffId();
    if (storedStaffId) setStaffId(storedStaffId);
    else setError("Staff ID not found in localStorage");

    try {
      const draft = JSON.parse(sessionStorage.getItem(HRA_DRAFT_KEY) || "null");
      if (draft) {
        if (draft.personalInfo) setPersonalInfo(draft.personalInfo);
        if (draft.answers) setAnswers(draft.answers);
        if (typeof draft.stepIndex === "number") setStepIndex(draft.stepIndex);
      } else if (gender) {
        setPersonalInfo((p) => ({ ...p, sex: gender === "Male" || gender === "Female" ? gender : "" }));
      }
    } catch {
      /* ponytail: ignore corrupt draft */
    }
  }, [gender]);

  useEffect(() => {
    if (!staffId) return;
    setLoading(true);
    setError("");

    getHraQuestions()
      .then((res) => {
        if (res.data.hraQuestions?.length > 0) {
          setAllQuestions(filterQuestionsByGender(res.data.hraQuestions, gender));
        } else {
          setAllQuestions([]);
          setError("No questions found");
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(`Error loading questions: ${err.message}`);
        setAllQuestions([]);
        setLoading(false);
      });
  }, [staffId, gender]);

  const categorySteps = useMemo(() => groupIntoFixedCategories(allQuestions), [allQuestions]);
  const totalSteps = 1 + FIXED_CATEGORY_COUNT;

  const findNextNonEmpty = useCallback(
    (fromIndex) => {
      for (let i = fromIndex + 1; i < totalSteps; i++) {
        if (categorySteps[i - 1]?.questions.length > 0) return i;
      }
      return null;
    },
    [categorySteps, totalSteps]
  );

  const findPrevNonEmpty = useCallback(
    (fromIndex) => {
      for (let i = fromIndex - 1; i >= 1; i--) {
        if (categorySteps[i - 1]?.questions.length > 0) return i;
      }
      return 0;
    },
    [categorySteps]
  );

  const getLastNonEmptyStepIndex = useCallback(() => {
    for (let i = categorySteps.length; i >= 1; i--) {
      if (categorySteps[i - 1].questions.length > 0) return i;
    }
    return 0;
  }, [categorySteps]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [stepIndex]);

  useEffect(() => {
    if (stepIndex > 0 && categorySteps[stepIndex - 1]?.questions.length === 0) {
      const next = findNextNonEmpty(stepIndex - 1);
      if (next != null) setStepIndex(next);
      else setStepIndex(findPrevNonEmpty(stepIndex));
    }
  }, [stepIndex, categorySteps, findNextNonEmpty, findPrevNonEmpty]);

  const isPersonalStep = stepIndex === 0;
  const currentCategoryStep = !isPersonalStep ? categorySteps[stepIndex - 1] : null;

  const stepLabel = isPersonalStep
    ? "Personal Information"
    : currentCategoryStep?.name || "Questions";

  const firstCategoryWithQuestions = categorySteps.find((s) => s.questions.length > 0);
  const lastNonEmptyStep = getLastNonEmptyStepIndex();

  const bmiValue = calcBmi({ ...personalInfo, unit: personalInfo.unit || "imperial" });
  const bmiLabel = bmiCategory(bmiValue);

  const personalValidation = useMemo(() => validatePersonalInfo(personalInfo), [personalInfo]);
  const personalStepValid = personalValidation.valid;

  const stepQuestions = currentCategoryStep?.questions || [];
  const stepAnswered = isPersonalStep
    ? personalStepValid
    : stepQuestions.length > 0 && stepQuestions.every((q) => answers[q._id]);

  const saveDraft = () => {
    sessionStorage.setItem(
      HRA_DRAFT_KEY,
      JSON.stringify({ stepIndex, answers, personalInfo })
    );
  };

  const handleSaveExit = () => {
    saveDraft();
    navigate("/hra-category");
  };

  const handleAnswerSelect = (questionId, optionId) => {
    setAnswers((prev) => {
      const next = { ...prev };
      if (optionId === null) delete next[questionId];
      else next[questionId] = optionId;
      return next;
    });
  };

  const buildPersonalInfoPayload = () => {
    const bmi = calcBmi({
      ...personalInfo,
      unit: personalInfo.unit || "imperial",
    });

    const category = bmiCategory(bmi);
    const metric = toMetricVitals(personalInfo);

    const bp =
      personalInfo.bpSys !== "" && personalInfo.bpDia !== ""
        ? {
          systolic: Number(personalInfo.bpSys),
          diastolic: Number(personalInfo.bpDia),
        }
        : null;

    return {
      ...personalInfo,
      bmi,
      bmiCategory: category,
      heightCm: Math.round(metric.heightCm * 10) / 10,
      weightKg: Math.round(metric.weightKg * 10) / 10,
      bp,
    };
  };

  const persistVitals = async (info) => {
    if (!staffId) return;

    const payload = {
      gender: info.sex,
      dob: info.dob,
      height: {
        unit: "metric",
        cm: Number(info.heightCm),
      },
      weight: {
        unit: "metric",
        value: Number(info.weightKg),
      },
      BP: info.bp,
      BMI: {
        value: info.bmi != null ? Number(info.bmi.toFixed(1)) : null,
        category: info.bmiCategory || null,
      },
    };

    try {
      await editProfile(staffId, payload);
    } catch (error) {
      console.error(
        "Failed to save health information:",
        error.response?.data || error.message
      );

      toast.error(
        error.response?.data?.message || "Failed to save health information."
      );
    }
  };

  const handleSubmit = (info) => {
    if (Object.keys(answers).length === 0) {
      toast.error("Please answer at least one question before submitting.");
      return;
    }

    const formattedAnswers = Object.keys(answers).map((qId) => ({
      questionId: qId,
      selectedOption: answers[qId],
    }));

    submitHraAnswers({ staffId, answers: formattedAnswers })
      .then((res) => {
        sessionStorage.removeItem(HRA_DRAFT_KEY);
        const responseData = res.data.data || res.data || {};
        const scores = computeHraScores(allQuestions, answers, responseData);
        toast.success(res.data.message || "Assessment completed successfully.");
        navigate("/hra-result", {
          state: {
            ...responseData,
            ...scores,
            totalQuestions: allQuestions.length,
            answeredQuestions: Object.keys(answers).length,
            message: res.data.message || "Assessment completed successfully",
            personalInfo: info,
            completedAt: new Date().toISOString(),
          },
        });
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || err.message || "Failed to submit assessment.");
      });
  };

  const handleNext = () => {
    if (isPersonalStep) {
      if (!personalStepValid) {
        setPersonalErrorsShown(true);
        return;
      }
      const info = buildPersonalInfoPayload();
      setSavedPersonalInfo(info);
      persistVitals(info);
      const next = findNextNonEmpty(0);
      if (next != null) setStepIndex(next);
      else handleSubmit(info);
      return;
    }
    if (stepIndex >= lastNonEmptyStep) {
      handleSubmit(savedPersonalInfo || buildPersonalInfoPayload());
      return;
    }
    const next = findNextNonEmpty(stepIndex);
    if (next != null) setStepIndex(next);
    else handleSubmit(savedPersonalInfo || buildPersonalInfoPayload());
  };

  const handleBack = () => {
    setStepIndex(findPrevNonEmpty(stepIndex));
  };

  const nextCategoryAfterCurrent = categorySteps
    .slice(stepIndex)
    .find((s) => s.questions.length > 0)?.name;

  const continueLabel = isPersonalStep
    ? `Continue to ${firstCategoryWithQuestions?.name || "Assessment"}`
    : stepIndex >= lastNonEmptyStep
      ? "Submit"
      : nextCategoryAfterCurrent
        ? `Continue to ${nextCategoryAfterCurrent}`
        : "Next Step";

  const renderContent = () => {
    if (loading) {
      return <LoadingState branded message="Loading questions…" />;
    }

    if (error) {
      return (
        <div className="mb-4 p-3 bg-error-container border border-error-container text-error rounded-xl text-sm">
          {error}
        </div>
      );
    }

    if (isPersonalStep) {
      return (
        <>
          <h2 className="text-xl font-bold text-on-primary-fixed-var mb-8">Personal Information</h2>
          <PersonalInfoStep
            personalInfo={personalInfo}
            setPersonalInfo={setPersonalInfo}
            bmiValue={bmiValue}
            bmiLabel={bmiLabel}
            errors={personalValidation.errors}
            showAllErrors={personalErrorsShown}
          />
        </>
      );
    }

    if (currentCategoryStep && stepQuestions.length > 0) {
      return (
        <>
          <h2 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var mb-2">
            {currentCategoryStep.name}
          </h2>
          <p className="text-sm text-on-surface-variant mb-8 leading-relaxed">
            {CATEGORY_DESCRIPTIONS[currentCategoryStep.name] || CATEGORY_DESCRIPTIONS.default}
          </p>
          <div className="space-y-6 sm:space-y-10">
            {stepQuestions.map((question, idx) => (
              <div key={question._id}>
                <p className="font-semibold text-on-primary-fixed-var mb-1">
                  {!isCheckboxStyle(question) && `${idx + 1}. `}
                  {question.question}
                </p>
                {question.instruction && (
                  <p className="text-xs text-on-surface-variant italic mb-4">{question.instruction}</p>
                )}
                {!question.instruction && !isCheckboxStyle(question) && <div className="mb-4" />}
                <QuestionInput
                  question={question}
                  selectedId={answers[question._id]}
                  onSelect={handleAnswerSelect}
                />
              </div>
            ))}
          </div>
        </>
      );
    }

    return <p className="text-center text-on-surface-variant py-12">No questions available.</p>;
  };

  return (
    <HraAssessmentShell
      stepIndex={stepIndex}
      totalSteps={totalSteps}
      stepLabel={stepLabel}
      onSaveExit={handleSaveExit}
      onBack={handleBack}
      onNext={handleNext}
      nextLabel={continueLabel}
      canProceed={stepAnswered && !loading && (isPersonalStep || (stepQuestions.length > 0 && !!currentCategoryStep))}
      showBack={!isPersonalStep}
    >
      {renderContent()}
    </HraAssessmentShell>
  );
};

export default HraQuestionsPage;
